import moment from 'moment';
import { matchPath } from 'react-router-dom';
import {
  corporateProfileInitializer,
  individualProfileInitializer,
  representativeProfileInitializer
} from './templates/my-profile';
import {
  GTM_BODY,
  GTM_BODY_ID,
  GTM_HEAD,
  GTM_HEAD_ID,
  WEB_PUSH_TITLE_TEXT,
  WEB_PUSH_BODY_TEXT,
  WEB_PUSH_OK_BTN_TEXT,
  WEB_PUSH_REJECT_BTN_TEXT,
  WEB_PUSH_OK_BTN_COLOR,
  WEB_PUSH_HIDE_POWERED_BY,
  WEB_PUSH_NOTIFY_TIME,
  WEB_PUSH_NOTIFY_SHOW_AFTER_TIME,
  CORPORATE,
  INDIVIDUAL,
  ERROR_TYPE,
  EVENT_NAME,
  FLOW_TYPE,
  createSIFTScript,
  INDIVIDUAL_POI,
  INDIVIDUAL_POA,
  APPLICANT_POI,
  REPRESENTATIVE_POI,
  APPLICANT_POA,
  REPRESENTATIVE_POA,
  INDIVIDUAL_PERSONAL_IMAGE,
  DOC_TIMELINE_HEADER,
  TOGGLE_FEATURE_COUNTRY_CODE,
  EU_REGION,
  NEW_KYC_ONBOARDING_FLOW,
  REGISTERED,
  INITIATED,
  MAX_LIMIT_NOTES,
  SG,
  IS_AMAZE,
  AU,
  NEVER_SHOW,
  FILE_FORMAT_EXT_IMAGE_ONLY,
  FILE_FORMAT_DOCUMENT_ONLY,
  FILE_FORMAT_VIDEO_ONLY,
  FILE_FORMAT_DOCUMENT_PDF_ONLY,
  NEW_ONBOARDING_FLOW_COUNTRY_LIST,
  UPSELLING_MODAL_SESSION_KEY,
  FEATURE_DISCOVERY_NEW_PAYMENT_METHOD,
  EKYC_RETRY_COUNT,
  IP_MODAL_OPEN,
  IN,
  DASHBOARD_URL,
  MY_INFO_RESGISTRATION_URL,
  USER_REGISTRATION_URL,
  EU,
  MANAGE_PAYMENT_OPTION_FLAG,
  REFERRAL_CODE,
  STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE,
  DEFAULT_AUTH_PATH,
  BASE_URL
} from './constants';
import { GTM_ID } from './config';
import CryptoJS from 'crypto-js';
import forge from 'node-forge';
import { makeApiCall as apiCall, getSourceCurrencies } from '../redux/actions/common/common-action';
import { store } from '../store';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { PERSONAL_DETAILS_FORM } from '../screens/user-flow/individual/personal-details/personal_details_initializer';
import filter from 'lodash/filter';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import template from 'lodash/template';
import {
  ADD_ICON,
  DISABLED_ICON,
  DOC_FILE_ICON,
  MINIMIZE_CARD_ICON,
  PDF_FILE_ICON,
  VIDEO_FILE_ICON
} from '@Images';
import {
  FLOW_TYPE_ONBOARDING,
  FLOW_TYPE_REFER,
  FLOW_TYPE_SEND_MONEY,
  PARAMETER_CHANGE,
  REFER_EARN,
  SIGNIN,
  SIGNUP,
  UPSELLING_TRANSACTION_INITIATED
} from './constants/eventsConstants';
import { getFlagValue, isFlagEnabled } from '../redux/actions/flagsmith/flagsmith-main';
import {
  APP_DOWNLOAD_PROMOTION,
  APPLE_PAY_CONFIG,
  SET_NEW_SIGNUP_USER
} from '../redux/action-contants';
import { camelCase, startCase, toLower } from 'lodash';
import { pushGeoLocationDataToCT } from './events/cleverTap';
import { setCsrfToken } from '../redux/actions/authentication/authentication-action';
import { ModalFactory } from '../components/modal/modal';
import NewInstapointsLogic from '../screens/instapoints-logic/new-instapoint-logic';
import { logEvent } from './events/logUserEvents';
import { LOG_TYPE } from './events/eventsConstants';
import { keyEnpt } from '../constants/evs/encryptionKey';
import { visaIdenPub } from '../constants/evs/visaPublicKey';
import { visaIdenPt } from '../constants/evs/visaPvtKey';
import { fatZebraIdenPt } from '../constants/evs/fatzebraPvtKey';
import { decodeHTMLEntities } from './html-decoder';
import { parseUserAgent } from 'react-device-detect';

export const compose =
  (...fn) =>
  (args) =>
    fn.reduceRight((acc, fn) => fn(acc(args)));

export const strip = (to) => (string) => string.length > to ? `${string.slice(0, to)}...` : string;
export const strip20 = strip(20);

export const setNoIcon = ({ currencyField, country_code, toggleFeature }) => {
  if (
    toggleFeature === true ||
    (toggleFeature.featureToggle && toggleFeature.featureToggle.toggleFeature)
  )
    if (EU_REGION.includes(country_code)) {
      return currencyField === 'destination_currency' ? true : false;
    }
  switch (country_code) {
    case 'IN':
      return true;
    case 'SG':
      return currencyField === 'destination_currency' ? true : false;
    case 'US':
      return true;
    case 'AU':
      return true;
    case 'MY':
      return true;
    case 'HK':
      return currencyField === 'destination_currency' ? true : false;
    case 'CA':
      return true;
    default:
      return false;
  }
};
export function timeout(ms, promise) {
  return Promise.race([
    promise,
    new Promise((resolve, reject) => setTimeout(reject, ms, new Error('timeout')))
  ]);
}

export function BuildUI(dataTemplate, headerCreator, fieldCreator, sectionCreator = null) {
  if (!headerCreator || !fieldCreator || !dataTemplate)
    throw new Error('dataTemplate, headerCreator or fieldCreator not provided');
  if (sectionCreator) {
    return dataTemplate.map((section, sectionIndex) =>
      sectionCreator(
        section,
        [headerCreator(section.sectionName, sectionIndex)].concat(
          section.fields.map((field, fieldIndex) => fieldCreator(field, fieldIndex, sectionIndex))
        )
      )
    );
  } else {
    return dataTemplate.reduce((acc, section, sectionIndex) => {
      return acc.concat([
        headerCreator(section.sectionName, sectionIndex),
        section.fields.map((field, fieldIndex) => fieldCreator(field, fieldIndex, sectionIndex))
      ]);
    }, []);
  }
}

export function fieldCreator(initial, inferClassName, inferValidation, inferNormalization) {
  const obj = initial;
  if (!obj.meta) obj.meta = {};
  inferClassName &&
    (obj.meta = Object.assign(obj.meta, {
      validation: inferClassName(obj)
    }));
  inferValidation &&
    (obj.meta = Object.assign(obj.meta, {
      validation: inferValidation(obj)
    }));
  inferNormalization &&
    (obj.meta = Object.assign(obj.meta, {
      validation: inferNormalization(obj)
    }));
  return obj;
}

export function mergeObjectArray(arr1 = [], arr2 = [], fieldName) {
  if (arr1.length === 0 || arr2.length === 0 || !fieldName) return [...arr1, ...arr2];
  const arr3 = [];
  for (const i in arr1) {
    let shared = false;
    for (const j in arr2)
      if (arr2[j][fieldName] === arr1[i][fieldName]) {
        shared = true;
        break;
      }
    if (!shared) arr3.push(arr1[i]);
  }
  return [...arr3, ...arr2];
}

export function mergeObjectAll(country, account_type, is_representative_profile, data) {
  switch (account_type) {
    case INDIVIDUAL:
      return individualProfileInitializer(country)(data);
    case CORPORATE: {
      if (is_representative_profile) return representativeProfileInitializer(country)(data);
      return corporateProfileInitializer(country)(data);
    }
    default:
      return null;
  }
}

export function setReduxFields(dispatch, change, formName, fieldsObj) {
  return Object.entries(fieldsObj || {}).forEach(([key, value]) =>
    dispatch(change(formName, key, value))
  );
}

export function untouchFields(dispatch, untouch, formName, fieldsObj) {
  return Object.keys(fieldsObj || {}).forEach((key) => {
    dispatch(untouch(formName, key));
  });
}

export function resetFields(formName, fieldsObj, dispatch, change, untouch, formSectionName) {
  return Object.entries(fieldsObj).forEach(([key, value]) => {
    dispatch(
      change(
        formName,
        ...(formSectionName
          ? [
              formSectionName,
              {
                [key]: value
              }
            ]
          : [key, value])
      )
    );
    dispatch(untouch(formName, formSectionName ? `${formSectionName}.${key}` : key));
  });
}

export function injectCDN(url) {
  const script = document.createElement('script');
  script.src = url;
  document.head.appendChild(script);
}

export function getNextScreen(screens, currentScreen) {
  if (screens) {
    for (let i = 0, iL = screens.length, found = -1; i < iL; i++)
      if (found === -1) {
        if (screens[i].name === currentScreen) found = i;
      } else if (screens[i].is_required) return screens[i].name;
  }
  return currentScreen;
}

export function uploadDocReqObj(params) {
  const { type, fieldName, code, fieldData = {}, otherFieldsData } = params;
  const returnObj = {
    fieldname: fieldName,
    type,
    code,
    identity_number: fieldData.identity_number || null,
    date_of_issue: fieldData.date_of_issue || null,
    date_of_expiry: fieldData.date_of_expiry || null,
    details: fieldData,
    ...otherFieldsData
  };
  delete fieldData.identity_number;
  delete fieldData.date_of_issue;
  delete fieldData.date_of_expiry;
  return returnObj;
}

export function uploadDocReqLogic(params) {
  const {
    documents,
    details,
    fileFieldName,
    formFileData,
    codeTypeList,
    docConfig,
    reqestedDocuments,
    is_back_document,
    isDocDetailIdSearched = false,
    updateDetailsOnly = false,
    representative_id,
    isDetailNotRequired
  } = params;
  let { docDetailId } = params;
  let reqestedData = null;
  const docDetails = {
    ...(details || {})
  };
  let docCountInDetails = 0;
  let updateFrontFileFieldName = null;
  let updateBackFileFieldName = null;

  const { type: docType, document_code: docCode } = docConfig;

  //doc id
  if (documents && documents.length > 0 && !isDocDetailIdSearched) {
    const docData = documents.find(
      (element) => element.type === docType && element.document_code === docCode
    );
    if (docData) docDetailId = docData.document_detail_id;
  }

  //append file
  if (fileFieldName) {
    const fileInfo = docDetails[fileFieldName];
    if (fileInfo && (fileInfo instanceof File || fileInfo instanceof Blob)) {
      let extension = fileInfo.type;
      if (fileInfo.name) {
        formFileData.append(fileFieldName, fileInfo, fileInfo.name);
      } else {
        extension = '.' + extension.split('/')[1];
        formFileData.append(fileFieldName, fileInfo, fileFieldName + extension);
      }
    }
  }

  //delete unwanted data from document details
  Object.keys(docDetails).forEach((item) => {
    if (item.indexOf('doc_file') > -1) {
      if (docDetails[item] instanceof File || docDetails[item] instanceof Blob) docCountInDetails++;
      if (item.indexOf('doc_file_back') > -1) {
        updateBackFileFieldName = item;
      } else if (item.indexOf('doc_file_front') > -1) {
        updateFrontFileFieldName = item;
      }
      if (!isDetailNotRequired) delete docDetails[item];
    }
  });

  if (!updateFrontFileFieldName && !updateBackFileFieldName && updateDetailsOnly) {
    return;
  }

  //code list
  codeTypeList.push({
    code: docCode,
    type: docType,
    details: {
      ...docDetails
    }
  });

  let otherFieldsData = {
    document_detail_id: docDetailId,
    is_KYC_oriented: true,
    is_transaction_oriented: false
  };

  //to make sure that back document details should also update the fron document details
  if (
    documents &&
    documents.length > 0 &&
    docCountInDetails !== 2 &&
    !updateDetailsOnly &&
    updateBackFileFieldName &&
    updateFrontFileFieldName
  ) {
    let updateDocData = null;
    if (is_back_document) {
      if (representative_id) {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            !element.is_back_document &&
            element.remitter_corporate_representative_id === representative_id
        );
      } else {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            !element.is_back_document
        );
      }
    } else {
      if (representative_id) {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            element.is_back_document &&
            element.remitter_corporate_representative_id === representative_id
        );
      } else {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            element.is_back_document
        );
      }
    }
    if (updateDocData) {
      const updateOtherFieldsData = {
        ...otherFieldsData,
        is_back_document: !is_back_document,
        document_detail_id: updateDocData.document_detail_id
      };
      /**
       * following fun returns the requested obj format that needs to be sent to the BE
       * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
       */
      const reqestedObj = {
        fieldName: is_back_document ? updateFrontFileFieldName : updateBackFileFieldName,
        type: docType,
        code: docCode,
        fieldData: !isDetailNotRequired
          ? {
              ...docDetails
            }
          : {},
        otherFieldsData: updateOtherFieldsData
      };
      reqestedData = uploadDocReqObj(reqestedObj);
      reqestedDocuments.push(reqestedData);
    }
  }

  //update only details of the documents
  if (updateDetailsOnly) {
    let updateDocData = null;
    if (representative_id) {
      updateDocData = documents.filter(
        (element) =>
          element.type === docType &&
          element.document_code === docCode &&
          element.remitter_corporate_representative_id === representative_id
      );
    } else {
      updateDocData = documents.filter(
        (element) => element.type === docType && element.document_code === docCode
      );
    }

    if (updateDocData && updateDocData.length > 0) {
      updateDocData.forEach((item) => {
        const updateOtherFieldsData = {
          ...otherFieldsData,
          is_back_document: item.is_back_document,
          document_detail_id: item.document_detail_id
        };
        /**
         * following fun returns the requested obj format that needs to be sent to the BE
         * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
         */
        const reqestedObj = {
          fieldName: item.is_back_document ? updateBackFileFieldName : updateFrontFileFieldName,
          type: docType,
          code: docCode,
          fieldData: !isDetailNotRequired
            ? {
                ...docDetails
              }
            : {},
          otherFieldsData: updateOtherFieldsData
        };
        reqestedData = uploadDocReqObj(reqestedObj);
        reqestedDocuments.push(reqestedData);
      });
    }
  } else {
    if (is_back_document !== undefined)
      otherFieldsData = {
        ...otherFieldsData,
        is_back_document
      };

    /**
     * following fun returns the requested obj format that needs to be sent to the BE
     * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
     */
    const reqestedObj = {
      fieldName: fileFieldName,
      type: docType,
      code: docCode,
      fieldData: !isDetailNotRequired
        ? {
            ...docDetails
          }
        : {},
      otherFieldsData
    };
    reqestedData = uploadDocReqObj(reqestedObj);
    reqestedDocuments.push(reqestedData);
  }
}

export function eVerifyReqObj({ code, fields }) {
  return {
    code,
    fields
  };
}

export function makeUrl(url, params) {
  return `${url}?${Object.entries(params)
    .map(([key, value]) =>
      key && value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null
    )
    .filter((part) => Boolean(part))
    .join('&')}`;
}

export function constructQueryParams(string) {
  if (!string) return {};
  const queries = string.replace('?', '').split('&');
  const object = {};
  queries.forEach((query) => {
    const [key, value] = query.split('=');
    object[key] = value;
  });
  return object;
}

export function getUTMQuery(query) {
  const { utm_medium, utm_source, utm_campaign, utm_content, utm_term } = constructQueryParams(query);
  if (!utm_source) return null;
  return {
    utm_medium,
    utm_source,
    utm_campaign,
    utm_content,
    utm_term
  };
}

export function expiresAfter(days) {
  const newDate = new Date();
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

export function setCookie(key, value, expires, path = '/') {
  document.cookie = `${key}=${value}; ${
    expires ? 'expires=' + expires.toUTCString() : ''
  }; secure; path=${path}; SameSite=Lax`;
}

export function getCookie(key) {
  const cookies = document.cookie.replace(/\s/g, '').split(';');
  for (let i = 0, iL = cookies.length; i < iL; i++) {
    const [_key, value] = cookies[i].split('=');
    if (_key === key) return value;
  }
  return null;
}

export function deleteCookie(name) {
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function sanitize(payload) {
  const clone = {},
    entries = Object.entries(payload);
  entries.forEach(
    ([key, value]) => (value !== null || value !== undefined) && (clone[key] = value)
  );
  return clone;
}

const sensitive = ['password', 'bank_account_number'];

export function deleteSensitiveInfo(data) {
  const clone = Object.assign({}, data);
  sensitive.forEach((key) => clone[key] && delete clone[key]);
  return clone;
}

export const injectIntoDataLayerWithEvent = (formID, formData) => {
  const { dataLayer } = window;
  try {
    if (formID === 'form-amaze') return;
    const injected = dataLayer.find((obj) => obj.formID === formID);
    if (!injected)
      dataLayer.push({
        event: formID,
        formData: deleteSensitiveInfo(formData)
      });
    else injected.formData = deleteSensitiveInfo(formData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
};

export function sendCleverTapEvent(eventName, ctData, pushProfile, profileData, _flowType) {
  const reduxStore = store.getState();
  const userData = get(reduxStore, 'rootReducer.userSessionReducer.user_session', {});
  const individualUser = userData.account_type === INDIVIDUAL;
  const country_consolidated =
    userData.country_code === 'GB'
      ? 'GB'
      : EU_REGION.includes(userData.country_code)
      ? 'EU'
      : userData.country_code;

  const { clevertap } = window;
  if (clevertap) {
    ctData = {
      ...ctData,
      ...(eventName === camelCase(SIGNUP) || eventName === camelCase(SIGNIN)
        ? {
            locale: navigator.language || navigator.userLanguage,
            browserName: getBrowserName(),
            ...(individualUser && {
              country_consolidated: country_consolidated
            })
          }
        : {})
    };
    clevertap.event.push(eventName, ctData);
    if (pushProfile) {
      clevertap.onUserLogin.push({
        Site: profileData
      });
    }
  } else {
    // eslint-disable-next-line no-console
    console.warn('no clevertap events could be recorded !!');
  }
}

export function injectIntoDataLayer(formID, formData) {
  const { dataLayer } = window;
  formData = {
    ...formData,
    ...{
      locale: navigator.language || navigator.userLanguage,
      flow_type: FLOW_TYPE.ONBOARDING
    }
  };
  try {
    if (formID === 'form-amaze') return;
    const injected = dataLayer.find((obj) => obj.formID === formID);
    if (!injected)
      dataLayer.push({
        event: 'gtm.form',
        formID,
        formData: deleteSensitiveInfo(formData)
      });
    else injected.formData = deleteSensitiveInfo(formData);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export const logCTEvent = (eventName, eventProperty = {}) => {
  const {
    rootReducer: {
      userSessionReducer: {
        user_session: { country_code, account_type }
      }
    }
  } = store.getState();

  const individualUser = account_type === INDIVIDUAL;
  const country_consolidated =
    country_code === 'GB' ? 'GB' : EU_REGION.includes(country_code) ? 'EU' : country_code;

  const ctData = {
    locale: navigator.language || navigator.userLanguage,
    browserName: getBrowserName(),
    ...(individualUser && { countryConsolidated: country_consolidated })
  };

  const { clevertap } = window;
  const ctaName = eventProperty?.ctaName?.toUpperCase();
  if (clevertap) {
    if (ctaName === 'SIGNUP' || ctaName === 'SIGNIN') {
      clevertap.event.push(eventName, { ...eventProperty, ...ctData });
    } else {
      clevertap.event.push(eventName, eventProperty);
    }
  }
};
export function addGTMHead() {
  let gtm_head_code = document.getElementById(GTM_HEAD_ID);
  if (!gtm_head_code) {
    gtm_head_code = document.createElement('script');
    gtm_head_code.setAttribute('id', GTM_HEAD_ID);
    gtm_head_code.innerHTML = GTM_HEAD(GTM_ID);
    document.head.appendChild(gtm_head_code);
  }
}

export function addGTMBody() {
  let gtm_body_code = document.getElementById(GTM_BODY_ID);
  if (!gtm_body_code) {
    gtm_body_code = document.createElement('noscript');
    gtm_body_code.setAttribute('id', GTM_BODY_ID);
    gtm_body_code.appendChild(GTM_BODY(GTM_ID));
    document.body.insertBefore(gtm_body_code, document.body.children[0]);
  }
}

/**
 * Attach the SIFT science SDK to the window
 */
export function addSiftScript() {
  const script_head = document.createElement('script');
  script_head.setAttribute('type', 'text/javascript');
  script_head.innerHTML = createSIFTScript();
  document.head.appendChild(script_head);
}

/**
 * Push page change events to Sift
 */
export function pushEventsToSift() {
  const _sift = (window._sift = window._sift || []);
  _sift.push(['_trackPageview']);
}

export function generateUniqueSessionId() {
  const name = 'Instarem',
    rChars =
      Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15),
    timeStamp = new Date();
  const session_id = name + '-' + rChars + '-' + timeStamp.getTime();
  return session_id || null;
}

export function getUniqueSessionId() {
  return generateUniqueSessionId();
}

export function getUserId() {
  const state = store.getState();
  return get(state, 'rootReducer.userSessionReducer.user_session.customer_id', null);
}

export function disableReturn(e) {
  return (
    (e.key === 'Enter' || (e.target.tagName === 'BUTTON' && e.key === ' ')) && e.preventDefault()
  );
}

export function scrollOnFormError(errors) {
  if (!errors) return;
  const keys = Object.keys(errors);
  if (keys.length && !keys[0].includes(':')) {
    let element = null;
    element = document.querySelector(
      `input[name=${keys[0]}], select[name=${keys[0]}],div[name=${keys[0]}]`
    );
    if (!element) {
      element = document.querySelector(`input[name=${keys[1]}], select[name=${keys[1]}]`);
    }
    element &&
      element.scrollIntoView({
        behavior: 'smooth'
      });
  }
}

export function createSafeDynamicRegex(string) {
  return string.replace(/[/\\+*()[\]?]/g, '');
}

export const getLocaleSpecificTime = (date, apiTimeFormat, requiredFormat) => {
  const utcTime = moment.utc(date, apiTimeFormat);
  const stillUtc = moment.utc(utcTime).toDate();
  return moment(stillUtc).local().format(requiredFormat);
};

export function formatCurrencyAmount(value) {
  if (!value || value === '0') return 0; //to handle removing leading zeros and only zero value
  //remove leading zero and added , separated values, but keep a single "0" before a decimal point (e.g. "0.5")
  return value
    .toString()
    .replace(/^0+(?=\d)/, '')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function formatCurrencyAmountReturningNonZero(value) {
  //remove leading zero and added , separated values
  return value
    .toString()
    .replace(/^0+/, '')
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function parseCurrency(value, dontAllowDecimal = false) {
  if (!value) return '0';
  return dontAllowDecimal ? value.replace(/[^0-9]/g, '') : value.replace(/,/g, '');
}

export function formatAmount(amount) {
  return Number(Number(amount).toFixed(2)).toLocaleString('en');
}

export function formatCurrencyToTwoDecimalPlaces(amount) {
  if (!Number(amount)) {
    return '0';
  } else if (Number(amount) % 1 === 0) {
    return Number(amount).toFixed(0).toLocaleString('en');
  } else {
    return Number(amount).toFixed(2).toLocaleString('en');
  }
}

export const duplicateValsInArray = (inputArray) =>
  inputArray.reduce(function (acc, el, i, arr) {
    if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
    return acc;
  }, []);

export function uploadDocLogic(param) {
  const {
    documents,
    details,
    fileFieldName,
    formFileData,
    codeTypeList,
    docConfig,
    reqestedDocuments,
    is_back_document,
    isDocDetailIdSearched = false,
    updateDetailsOnly = false,
    representative_id,
    isDetailNotRequired
  } = param;
  let { docDetailId } = param;
  let reqestedData = null;
  const docDetails = {
    ...(details || {})
  };
  let docCountInDetails = 0;
  let updateFrontFileFieldName = null;
  let updateBackFileFieldName = null;

  const { type: docType, document_code: docCode } = docConfig;

  //doc id
  if (documents && documents.length > 0 && !isDocDetailIdSearched) {
    const docData = documents.find(
      (element) => element.type === docType && element.document_code === docCode
    );
    if (docData) docDetailId = docData.document_detail_id;
  }

  //append file
  if (fileFieldName) {
    const fileInfo = docDetails[fileFieldName];
    if (fileInfo && (fileInfo instanceof File || fileInfo instanceof Blob)) {
      let extension = fileInfo.type;
      if (fileInfo.name) {
        formFileData.append(fileFieldName, fileInfo, fileInfo.name);
      } else {
        extension = '.' + extension.split('/')[1];
        formFileData.append(fileFieldName, fileInfo, fileFieldName + extension);
      }
    }
  }

  //delete unwanted data from document details
  Object.keys(docDetails).forEach((item) => {
    if (item.indexOf('doc_file') > -1) {
      if (docDetails[item] instanceof File || docDetails[item] instanceof Blob) docCountInDetails++;
      if (item.indexOf('doc_file_back') > -1) {
        updateBackFileFieldName = item;
      } else if (item.indexOf('doc_file_front') > -1) {
        updateFrontFileFieldName = item;
      }
      if (!isDetailNotRequired) delete docDetails[item];
    }
  });

  if (!updateFrontFileFieldName && !updateBackFileFieldName && updateDetailsOnly) {
    return;
  }

  //code list
  codeTypeList.push({
    code: docCode,
    type: docType,
    details: {
      ...docDetails
    }
  });

  let otherFieldsData = {
    document_detail_id: docDetailId,
    is_KYC_oriented: true,
    is_transaction_oriented: false
  };

  //to make sure that back document details should also update the fron document details
  if (
    documents &&
    documents.length > 0 &&
    docCountInDetails !== 2 &&
    !updateDetailsOnly &&
    updateBackFileFieldName &&
    updateFrontFileFieldName
  ) {
    let updateDocData = null;
    if (is_back_document) {
      if (representative_id) {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            !element.is_back_document &&
            element.remitter_corporate_representative_id === representative_id
        );
      } else {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            !element.is_back_document
        );
      }
    } else {
      if (representative_id) {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            element.is_back_document &&
            element.remitter_corporate_representative_id === representative_id
        );
      } else {
        updateDocData = documents.find(
          (element) =>
            element.type === docType &&
            element.document_code === docCode &&
            element.is_back_document
        );
      }
    }
    if (updateDocData) {
      const updateOtherFieldsData = {
        ...otherFieldsData,
        is_back_document: !is_back_document,
        document_detail_id: updateDocData.document_detail_id
      };
      /**
       * following fun returns the requested obj format that needs to be sent to the BE
       * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
       */
      const reqestedObj = {
        fieldName: is_back_document ? updateFrontFileFieldName : updateBackFileFieldName,
        type: docType,
        code: docCode,
        fieldData: !isDetailNotRequired
          ? {
              ...docDetails
            }
          : {},
        otherFieldsData: updateOtherFieldsData
      };
      reqestedData = uploadDocReqObj(reqestedObj);
      reqestedDocuments.push(reqestedData);
    }
  }

  //update only details of the documents
  if (updateDetailsOnly) {
    let updateDocData = null;
    if (representative_id) {
      updateDocData = documents.filter(
        (element) =>
          element.type === docType &&
          element.document_code === docCode &&
          element.remitter_corporate_representative_id === representative_id
      );
    } else {
      updateDocData = documents.filter(
        (element) => element.type === docType && element.document_code === docCode
      );
    }

    if (updateDocData && updateDocData.length > 0) {
      updateDocData.forEach((item) => {
        const updateOtherFieldsData = {
          ...otherFieldsData,
          is_back_document: item.is_back_document,
          document_detail_id: item.document_detail_id
        };
        /**
         * following fun returns the requested obj format that needs to be sent to the BE
         * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
         */
        const reqestedObj = {
          fieldName: item.is_back_document ? updateBackFileFieldName : updateFrontFileFieldName,
          type: docType,
          code: docCode,
          fieldData: !isDetailNotRequired
            ? {
                ...docDetails
              }
            : {},
          otherFieldsData: updateOtherFieldsData
        };
        reqestedData = uploadDocReqObj(reqestedObj);
        reqestedDocuments.push(reqestedData);
      });
    }
  } else {
    if (is_back_document !== undefined)
      otherFieldsData = {
        ...otherFieldsData,
        is_back_document
      };

    /**
     * following fun returns the requested obj format that needs to be sent to the BE
     * uploadDocReqObj({fieldName, type, code, fieldData, otherFieldsData})
     */
    const reqestedObj = {
      fieldName: fileFieldName,
      type: docType,
      code: docCode,
      fieldData: !isDetailNotRequired
        ? {
            ...docDetails
          }
        : {},
      otherFieldsData
    };
    reqestedData = uploadDocReqObj(reqestedObj);
    reqestedDocuments.push(reqestedData);
  }
}

export function getScrollTop() {
  return (
    window.scrollY ||
    window.pageYOffset ||
    document.body.scrollTop ||
    (document.documentElement ? document.documentElement.scrollTop : 0)
  );
}

export function fontSizeAdjust(amount = 0) {
  if (!amount) amount = 0;
  const length = amount.toLocaleString('en').length;
  if (length > 14) return 'size5';
  if (length > 13) return 'size4';
  if (length > 12) return 'size3';
  if (length > 10) return 'size2';
  if (length > 8) return 'size1';
  return '';
}

export function promiseSetState(context) {
  return function (args) {
    return new Promise((resolve) => context.setState(args, resolve));
  };
}

export function joinClassNames() {
  return [...arguments]
    .filter(
      (className) =>
        Boolean(className) && (typeof className === 'string' || className instanceof String)
    )
    .join(' ');
}

export function promiseSetTimeout(cb, timeout, ...args) {
  return new Promise((resolve) => setTimeout(async () => resolve(await cb(...args)), timeout));
}

export const getBrowserName = () => {
  // Check for Brave specifically
  if (navigator.brave && navigator.brave.isBrave) {
    return 'Brave';
  }

  const agent = window.navigator.userAgent.toLowerCase();

  // Detailed browser detection
  if (agent.includes('edg')) return 'Microsoft Edge';
  if (agent.includes('opr')) return 'Opera';
  if (agent.includes('vivaldi')) return 'Vivaldi';
  if (agent.includes('firefox')) return 'Mozilla Firefox';

  // Chrome detection (must come after other Chromium-based browsers)
  if (agent.includes('chrome')) return 'Google Chrome';

  // Safari detection (must not include chrome)
  if (agent.includes('safari') && !agent.includes('chrome')) return 'Safari';

  if (agent.includes('trident') || agent.includes('msie')) return 'Internet Explorer';

  return 'Unknown Browser';
};

function initializeObject(object, initial) {
  if (!object) return initial;
  if (!initial) return object;
  const keys = Object.keys(object);

  if (!keys.length) return initial;
  return keys.reduce(
    (object, key) => {
      let value = object[key];
      // eslint-disable-next-line no-prototype-builtins
      if (!initial.hasOwnProperty(key)) return object;
      if (value instanceof Object) value = initializeObject(value, initial[key]);
      else value = initial[key];
      object[key] = value;
      return object;
    },
    {
      ...object
    }
  );
}

export function checkAllEmptyArrayValues(ar) {
  return ar && ar.every((a) => a === '' || !a);
}
export function initializeForm(getConstruct, initial) {
  return initializeObject(
    getConstruct ? (getConstruct instanceof Function ? getConstruct() : getConstruct) : {},
    initial
  );
}

export function getInstapointTooltip(min, max) {
  return `You earn Instarem reward points 'InstaPoints' on each transfer and can redeem ${
    min === max ? min : `between ${min} and ${max}`
  } per transfer. Please read more on InstaPoints at our Help Center.`;
}

export function encryptData(data) {
  return data ? CryptoJS.AES.encrypt(data, keyEnpt ?? '').toString() : '';
}

export function decryptData(data) {
  const privateKey = forge.pki.privateKeyFromPem(fatZebraIdenPt);
  return privateKey.decrypt(forge.util.decode64(data), 'RSAES-PKCS1-V1_5');
}

export function encryptDataWithSignature(data) {
  const publicKey = forge.pki.publicKeyFromPem(visaIdenPub ?? '');
  const encryptedBytes = publicKey.encrypt(data, 'RSAES-PKCS1-V1_5');
  const encryptedData = forge.util.encode64(encryptedBytes);

  const privateKey = forge.pki.privateKeyFromPem(visaIdenPt ?? '');
  const md = forge.md.sha256.create();
  md.update(data, 'utf8');
  const signatureBytes = privateKey.sign(md);
  const signature = forge.util.encode64(signatureBytes);

  return {
    encryptedData,
    signature
  };
}

export const checkParamInURL = (paramString) => {
  const url = window.location.search;
  const params = new URLSearchParams(url);
  return params.get(paramString);
};

export function mergeArraysByParameter(obj1, obj2, p) {
  const resultArray = [];
  obj1.forEach((key1) => {
    obj2.forEach((key2) => {
      if (key1[p] === key2[p]) {
        let ob = {
          ...key1,
          ...key2
        };
        if (ob.details) {
          ob = {
            ...ob,
            ...ob.details
          };
        }
        resultArray.push(ob);
      }
    });
  });
  return resultArray;
}

export function flattenObject(ob) {
  const toReturn = {};
  for (const i in ob) {
    // eslint-disable-next-line no-prototype-builtins
    if (!ob.hasOwnProperty(i)) continue;
    if (typeof ob[i] === 'object' && !(ob[i] instanceof File) && !(ob[i] instanceof Blob)) {
      const flatObject = flattenObject(ob[i]);
      for (const x in flatObject) {
        // eslint-disable-next-line no-prototype-builtins
        if (!flatObject.hasOwnProperty(x)) continue;
        toReturn[i + '.' + x] = flatObject[x];
      }
    } else {
      toReturn[i] = ob[i];
    }
  }
  return toReturn;
}

export function setStreetforAddress(countryCode, streetName, streetType) {
  if (countryCode && (streetName || streetType))
    /**TODO */
    switch (countryCode) {
      case 'AU':
      case 'US':
      case 'CA':
        return {
          street: (streetName || '') + ' ' + (streetType || '')
        };
      default:
        return {};
    }
  else return {};
}

export function setMalaysiaAddress(data) {
  const residential = {};
  const mailing = {};
  Object.keys(PERSONAL_DETAILS_FORM.residential).forEach((key) => {
    residential[key] = data?.[key];
  });
  if (data?.mailing_address) {
    Object.keys(PERSONAL_DETAILS_FORM.mailing).forEach((key) => {
      mailing[key] = data['mailing_address'][key];
    });
  }
  return { residential, mailing };
}

export function getFileExtension(fileName) {
  if (fileName) return fileName.substring(fileName.lastIndexOf('.'), fileName.length);
  else return false;
}

export function converBase64toBlob(content, contentType) {
  contentType = contentType || '';
  const sliceSize = 512;
  const byteCharacters = window.atob(content); //method which converts base64 to binary
  const byteArrays = [];
  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  return new Blob(byteArrays, {
    type: contentType
  }); //statement which creates the blob
}

/**
 * Web Push Permision
 */
export function clervertapNotificationAfterTimeout() {
  setTimeout(clevertapWebPushNotifications, WEB_PUSH_NOTIFY_SHOW_AFTER_TIME);
}

export function clevertapWebPushNotifications() {
  if (window.clevertap) {
    window.clevertap.notifications.push({
      titleText: WEB_PUSH_TITLE_TEXT,
      bodyText: WEB_PUSH_BODY_TEXT,
      okButtonText: WEB_PUSH_OK_BTN_TEXT,
      rejectButtonText: WEB_PUSH_REJECT_BTN_TEXT,
      okButtonColor: WEB_PUSH_OK_BTN_COLOR,
      hidePoweredByCT: WEB_PUSH_HIDE_POWERED_BY,
      serviceWorkerPath: `${process.env.PUBLIC_URL}/clevertap_sw.js`
    });

    const send_data = {},
      notifyBtnOnClick = function (userDecision) {
        send_data.selected = userDecision;
        window.clevertap.event.push('WebPushPermission', send_data);
      };

    document.addEventListener(
      'click',
      (event) => {
        if (event.target.matches('#wzrk-cancel')) notifyBtnOnClick('Block');
        if (event.target.matches('#wzrk-confirm')) notifyBtnOnClick('Allow');
      },
      false
    );

    //remove notification after some interval
    setTimeout(() => {
      const removedElement = '';
      if (!removedElement)
        // eslint-disable-next-line no-console
        console.log('Push Notification not found!');
    }, WEB_PUSH_NOTIFY_TIME);
  }
}

/**
 * excludes dates for MY appointment dates
 * @type {array}
 * 2019 JAN 1 - New Year
 * 2019 JAN 21 - Thaipusam Cavadee
 * 2019 FEB 1 - Federal Territory Day
 * 2019 FEB 5 - Chinese New Year
 * 2019 FEB 6 - Chinese New Year
 * 2019 MAY 1 - Labour Day
 * 2019 MAY 19 - Wesak Day
 * 2019 MAY 20 - Mon after Wesak Day
 * 2019 MAY 22 - Nuzul Al - Quran
 * 2019 JUN 5 - Hari Raya Puasa
 * 2019 JUN 6 - Hari Raya Puasa
 * 2019 AUG 12 - Mon after Hari Raya Qurban
 * 2019 AUG 31 - National Day
 * 2019 SEP 2 - Awal Muharram
 * 2019 SEP 9 - Agong's Birthday
 * 2019 SEP 16 - Malaysia Day
 * 2019 OCT 28 - Mon after Deepavali
 * 2019 NOV 9 - Maulidur Rasul
 * 2019 DEC 25 - Christmas
 */
export const EXCLUDE_MY_APPOINTMENT_DATES = [
  moment([2019, 0, 1]),
  moment([2019, 0, 21]),
  moment([2019, 1, 1]),
  moment([2019, 1, 5]),
  moment([2019, 1, 6]),
  moment([2019, 4, 1]),
  moment([2019, 4, 19]),
  moment([2019, 4, 20]),
  moment([2019, 4, 22]),
  moment([2019, 5, 5]),
  moment([2019, 5, 6]),
  moment([2019, 7, 12]),
  moment([2019, 7, 31]),
  moment([2019, 8, 2]),
  moment([2019, 8, 9]),
  moment([2019, 8, 16]),
  moment([2019, 9, 28]),
  moment([2019, 10, 9]),
  moment([2019, 11, 25])
];

/**
 * Remove element from DOM using ID
 */
export function removeElementById(id) {
  const elem = document.getElementById(id);
  return elem && elem.parentNode.removeChild(elem);
}
export function removeKeys(data, keys) {
  Object.keys(data).forEach((k) => {
    if (k in keys) {
      delete data[k];
    }
  });
}

export const checkFieldInFormSection = (allValues, field_name, index, subString) => {
  const sections = field_name.split('.');
  let reqSection = allValues;
  let i,
    sectionFound = false,
    fieldFound = false;
  for (i = 0; i < index; i++) {
    if (reqSection[sections[i]]) {
      reqSection = reqSection[sections[i]];
      sectionFound = true;
    } else {
      sectionFound = false;
      break;
    }
  }
  if (sectionFound)
    Object.keys(reqSection).forEach((k) => {
      if (k.includes(subString) && k !== sections[index]) {
        fieldFound = true;
      }
    });
  return fieldFound;
};

function getExactTime({ createdAt, totalHrsLimit, callback }) {
  const totalLimit = totalHrsLimit * 60 * 60 * 1000;

  const createdAtTime = moment(createdAt).valueOf();
  const now = moment().valueOf();

  const diff = now - createdAtTime;
  let distance = totalLimit - diff;

  distance = Math.floor(distance / (60 * 1000));

  const hours = Math.floor(distance / 60);
  const minutes = Math.floor(distance % 60);

  if (typeof callback === 'function') {
    callback({
      hours,
      minutes,
      isExpired: distance < 0 ? true : false
    });
  }
  return distance;
}

export function timelineBlinker({ createdAt, totalHrsLimit, callback }) {
  getExactTime({
    createdAt,
    totalHrsLimit,
    callback
  });
  const x = setInterval(function () {
    const distance = getExactTime({
      createdAt,
      totalHrsLimit,
      callback
    });
    if (distance < 0) {
      if (typeof callback === 'function') {
        callback({
          isExpired: true
        });
      }
      clearInterval(x);
    }
  }, 60000);
}

export const computeWithTxn = async (mainConverter, isSourceAmountChanged) => {
  await mainConverter.setState({
    shouldSubmitDisabled: true
  });
  return isSourceAmountChanged
    ? mainConverter.onSourceAmountChange()
    : mainConverter.onDestinationAmountChange();
};

export const createCTObj = ({ error_type, error, flow_type, error_code }) => {
  return {
    error_type,
    error_code,
    flow_type,
    error_message:
      error_code === 0 ? JSON.stringify(error) : error?.response?.data?.data?.message ?? '',
    success: error && Object.keys(error).length === 0 ? 'true' : 'false',
    locale: navigator.language || navigator.userLanguage,
    error_count: error_code === 0 ? error && Object.keys(error).length : 'NA'
  };
};

export const networkCall = async (
  { method, url, data = {}, params = {}, headers = {} },
  dispatch,
  postData,
  { formID, ...requiredDataLayerObj },
  doInject = true
) => {
  requiredDataLayerObj = {
    ...requiredDataLayerObj,
    ...postData
  };
  let payload = {};
  switch (method) {
    case 'patch':
      payload = {
        ...payload,
        data
      };
      break;
    case 'get':
      payload = {
        ...payload,
        params
      };
      break;
    case 'post':
      payload = {
        ...payload,
        data
      };
      break;
    default:
      break;
  }

  try {
    const apiData = {
      method,
      url,
      withCredentials: true,
      ...payload
    };
    if (!isEmpty(headers)) {
      apiData['headers'] = headers;
    }
    const response = await apiCall(apiData);
    if (doInject) injectIntoDataLayer(formID, requiredDataLayerObj);
    return response;
  } catch (error) {
    const respData = error?.response?.data;
    //GTM call
    const createCTObjReq = createCTObj({
      error_type: ERROR_TYPE.SYSTEM,
      error,
      flow_type: EVENT_NAME[formID] && EVENT_NAME[formID].flowType,
      error_code: respData?.data?.statusCode || error?.response?.status
    });
    requiredDataLayerObj = {
      ...requiredDataLayerObj,
      ...createCTObjReq
    };
    if (formID === 'form-sign-in') {
      injectIntoDataLayer(EVENT_NAME[formID] && EVENT_NAME[formID].formName, requiredDataLayerObj);
    } else {
      injectIntoDataLayer(formID, requiredDataLayerObj);
    }
    throw error;
  }
};

export const signPassToClevertap = (value) => {
  let pageName = '';
  let selectedVerificationType = '';
  switch (value) {
    case 'PersonalDetails':
      pageName = 'PersonalDetails';
      selectedVerificationType = 'MyInfo';
      break;

    case 'MyInfo':
      pageName = 'Verification';
      selectedVerificationType = 'MyInfo';
      break;

    case 'Doc Upload':
      pageName = 'Doc Upload';
      selectedVerificationType = 'MyInfo';
      break;

    case 'manual':
      pageName = 'Verification';
      selectedVerificationType = 'Manual';
      break;

    case 'secondary':
      pageName = 'PersonalDetails';
      selectedVerificationType = 'MyInfo';
      break;
    default:
      break;
  }
  const ctData = {
    pageName: pageName,
    selectedVerificationType: selectedVerificationType,
    CTA: value === 'secondary' ? 'secondary' : null
  };
  logEvent('SG_VerificationType', FLOW_TYPE_ONBOARDING, ctData, LOG_TYPE.CLEVER_TAP);
};

function decodeArrayData(data = []) {
  return data.map((elem) => {
    if (Array.isArray(elem)) {
      return decodeArrayData(elem);
    } else if (elem && typeof elem === 'object') {
      return decodeResponseBody(elem);
    } else if (elem && typeof elem === 'string') {
      return decodeHTMLEntities(elem);
    } else {
      return elem;
    }
  });
}

export function decodeResponseBody(body = {}) {
  if (body && typeof body === 'object' && !(body instanceof Blob)) {
    const obj = {};
    Object.keys(body).forEach((key) => {
      if (Array.isArray(body[key])) {
        obj[key] = decodeArrayData(body[key]);
      } else if (body[key] && typeof body[key] === 'object') {
        obj[key] = decodeResponseBody(body[key]);
      } else if (body[key] && typeof body[key] === 'string') {
        obj[key] = decodeHTMLEntities(body[key]);
      } else {
        obj[key] = body[key];
      }
    });
    return obj;
  }
  return body;
}

export function convertHoursToDays(hours) {
  return Math.round(hours / 24);
}

export function getScreensAndTimeline(data, screen_name, oldTimeLine) {
  let currentUserIndex = 0,
    isValidScreen = false;
  const newData = data.reduce(
    (acc, { label, timeline_sequence, screens, timeline_meta, key }, index) => {
      key = label ? label.replace(/[ ]/g, '_').toLowerCase() : key;
      const timelineMeta = get(find(oldTimeLine, { key: key }), 'timeline_meta', null);
      acc.timeLine.push({
        label,
        timeline_sequence,
        status: timeline_sequence < 0 ? 'completed' : 'pending',
        timeline_meta: timeline_meta || timelineMeta,
        key
      });

      //flattens the sub screen and also infers if the user had left at this timeline sequence
      const { subs, contains } = extractSubScreens(screens, timeline_sequence, screen_name);
      acc.screens = [...acc.screens, ...subs];

      //if the user left at this timeline, we restore that index
      if (contains) {
        currentUserIndex = index;
        isValidScreen = true;
      }
      return acc;
    },
    { screens: [], timeLine: [] }
  );
  const { screens, timeLine } = newData;

  if (timeLine[currentUserIndex].timeline_sequence <= 0) {
    timeLine[currentUserIndex].status = 'completed';
    currentUserIndex = 1;
  }

  //all previous timelines are marked completed
  if (isValidScreen)
    for (let i = 0, iL = currentUserIndex; i < iL; i++) timeLine[i].status = 'completed';

  //successfully restored client's timeline index
  timeLine[currentUserIndex].status = 'processing';
  const currentScreen = screen_name && isValidScreen ? screen_name : screens[0].name;
  return { screens, timeLine, currentScreen };
}
function extractSubScreens(screens, timeline_sequence, screen_name) {
  let contains = false;
  const subs = screens.map(({ name, is_required, sequence }) => {
    if (!contains) contains = name === screen_name;
    return { name, is_required, timeline_sequence, sequence };
  });
  const newSubs = sortBy(subs, (obj) => obj.sequence);
  return {
    contains,
    subs: newSubs
  };
}

export function getDocumentTimeLineObject(timeLine) {
  const newTimeLine = [];
  const POI_DOCS = [INDIVIDUAL_POI, APPLICANT_POI, REPRESENTATIVE_POI];
  const POA_DOCS = [INDIVIDUAL_POA, APPLICANT_POA, REPRESENTATIVE_POA];
  const PERSONAL_IMG_DOCS = [INDIVIDUAL_PERSONAL_IMAGE];
  const timelineSorted = filter([...POI_DOCS, ...POA_DOCS, ...PERSONAL_IMG_DOCS], (item) => {
    return timeLine.indexOf(item) !== -1;
  });
  timelineSorted.forEach((item) => {
    let visibleText = '';
    if (POI_DOCS.includes(item)) {
      visibleText = DOC_TIMELINE_HEADER.IDENTITY;
    } else if (POA_DOCS.includes(item)) {
      visibleText = DOC_TIMELINE_HEADER.ADDRESS;
    } else if (PERSONAL_IMG_DOCS.includes(item)) {
      visibleText = DOC_TIMELINE_HEADER.PERSONAL_IMAGE;
    }
    newTimeLine.push({
      key: item,
      value: visibleText
    });
  });
  return newTimeLine;
}

export function getCurrentDocScreen(renderObject) {
  if (Object.keys(renderObject).includes('POI') && renderObject['POI'][0].is_doc_render_visible) {
    return { key: 'POI', value: DOC_TIMELINE_HEADER.IDENTITY };
  } else if (
    Object.keys(renderObject).includes('POA') &&
    renderObject['POA'][0].is_doc_render_visible
  ) {
    return { key: 'POA', value: DOC_TIMELINE_HEADER.ADDRESS };
  } else if (
    Object.keys(renderObject).includes('PERSONAL_IMAGE') &&
    renderObject['PERSONAL_IMAGE'][0].is_doc_render_visible
  ) {
    return { key: 'PERSONAL_IMAGE', value: DOC_TIMELINE_HEADER.PERSONAL_IMAGE };
  }
  return { key: null, value: null };
}

export function generateKey() {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export const country_code_with_new_flow = (countryCode) =>
  TOGGLE_FEATURE_COUNTRY_CODE.includes(countryCode);

export const copyCommand = (inputId) => {
  const target = document.getElementById(inputId);
  let range, select;
  if (document.createRange) {
    range = document.createRange();
    range.selectNode(target);
    select = window.getSelection();
    select.removeAllRanges();
    select.addRange(range);
    document.execCommand('copy');
    select.removeAllRanges();
  } else {
    range = document.body.createTextRange();
    range.moveToElementText(target);
    range.select();
    document.execCommand('copy');
  }
  logEvent(REFER_EARN, FLOW_TYPE_REFER, {}, LOG_TYPE.CLEVER_TAP);
};
export const copyHtmlCommand = (htmlContent) => {
  const tempContainer = document.createElement('div');
  tempContainer.innerHTML = htmlContent;
  document.body.appendChild(tempContainer);
  const range = document.createRange();
  range.selectNodeContents(tempContainer);
  const selection = window.getSelection();
  selection.removeAllRanges();
  selection.addRange(range);
  document.execCommand('copy');
  document.body.removeChild(tempContainer);
};

export function findDebitCardType(cardNumber) {
  const regexPattern = {
    MASTERCARD: /^5[1-5][0-9]{1,}|^2[2-7][0-9]{1,}$/,
    VISA: /^4[0-9]{2,}$/
  };
  for (const card in regexPattern) {
    if (cardNumber.replace(/[^\d]/g, '').match(regexPattern[card])) return card;
  }
  return false;
}

export const isBeneServiceRenderingApplicable = (
  beneSchemaApplicableCountries,
  bank_account_country,
  currency_code
) => {
  return !isEmpty(
    find(beneSchemaApplicableCountries, {
      country_code: bank_account_country,
      currency_code: currency_code
    })
  );
};

export const isKYCSplitFlow = (
  country_code,
  status = '',
  toggleFeatureCheckNeeded = true,
  defaultAccountType = ''
) => {
  const reduxStore = store.getState();
  const accountType =
    defaultAccountType || get(reduxStore, 'rootReducer.userStatusReducer.account_type', '');
  let result = NEW_KYC_ONBOARDING_FLOW.includes(country_code) && [INDIVIDUAL].includes(accountType);
  if (result && toggleFeatureCheckNeeded) {
    /* We didn't get MULTIVARIATE value in case of direct flagsmith call.
    Since, we are not using this, just returning on the basis of flagEnabled or not
    let splitKYCConfiguration = get(
      reduxStore,
      'rootReducer.userStatusReducer.split_kyc_configuration',
      {}
    );
    if (splitKYCConfiguration && Object.keys(splitKYCConfiguration).length > 0) {
      const splitKyc = get(splitKYCConfiguration, 'data', 'DEFAULT');
      const featureEnabled = get(splitKYCConfiguration, 'isFeatureEnabled', false);
      result = featureEnabled && splitKyc === SPLIT_KYC_ON;
    } else {
      result = false;
    }
    */
    result = false;
  }
  if (status && result) {
    result = [REGISTERED, INITIATED].includes(status);
  }
  return result;
};

export const addCardContent = (limits, country_code, type, cardType) => {
  switch (country_code) {
    case SG:
    case AU:
    case 'US':
      if (
        ['credit', 'CHECKOUT_AU_CREDIT', 'CHECKOUT_US_CREDIT', 'STRIPE_SG_CREDIT'].includes(
          cardType
        )
      ) {
        if (type === 'max_limit') return MAX_LIMIT_NOTES['CREDIT'];
        return `Add upto ${limits} credit cards`;
      }
      if (type === 'max_limit') return MAX_LIMIT_NOTES['DEBIT'];
      return `Add upto ${limits} debit cards`;
    default:
      if (type === 'max_limit') return MAX_LIMIT_NOTES['DEBIT'];
      return `Add upto ${limits} debit cards`;
  }
};

export const isAmazeFlow = (country_code, account_type) => {
  return IS_AMAZE.includes(country_code) && account_type === INDIVIDUAL;
};

export const isIndividual = (account_type) => {
  if (isEmpty(account_type)) {
    const reduxStore = store.getState();
    return get(reduxStore, 'rootReducer.userStatusReducer.account_type', '') === INDIVIDUAL;
  }
  return account_type === INDIVIDUAL;
};

//isBirthdayWeek =( birthdate - 3days )+ (birthdate + 3days)
export const isBirthdayWeek = () => {
  const reduxStore = store.getState();
  const dob = reduxStore.rootReducer.userStatusReducer.date_of_birth;
  if (!dob) return false;

  const birthdayStartDate = moment(dob, 'DD/MM').subtract(3, 'days');
  const birthdayEndDate = moment(dob, 'DD/MM').add(3, 'days');
  const currentDate = moment();
  return moment(currentDate, 'YYYY-MM-DD').isBetween(
    birthdayStartDate,
    birthdayEndDate,
    'days',
    true
  );
};

export const compileTemplate = (textString, values) => {
  try {
    const compiled = template(textString, {
      interpolate: /{{{([\s\S]+?)}}}/g
    });
    return compiled(values);
  } catch (e) {
    return textString;
  }
};

export const compileAndConvertNewlines = (textString, values) => {
  // Call the compileTemplate function to get the processed template string
  const compiledString = compileTemplate(textString, values);
  const compiledTags = compiledString.replace(
    /<a(.*?)>/g,
    (match, group1) => `<a${group1} target="_blank">`
  );
  return compiledTags;
};

/* extraction from single curly brace */
export const compileTemplateNew = (textString, values, returnHtml = false) => {
  try {
    const compiled = template(textString, {
      interpolate: /{([\s\S]+?)}/g
    });
    if (returnHtml) return { __html: compiled(values) };
    return compiled(values);
  } catch (e) {
    return textString;
  }
};

export const compileTemplateNewWithStyling = (textString, values) => {
  return textString.split(/{([\s\S]+?)}/g).map((part, index) => {
    if (values[part]) {
      return <span key={index}>{values[part]}</span>;
    }
    return part;
  });
};

export const isPaymentMethodNewlyAdded = (paymentMethod) => {
  const newPaymentMethods =
    (isFlagEnabled(FEATURE_DISCOVERY_NEW_PAYMENT_METHOD) &&
      getFlagValue(FEATURE_DISCOVERY_NEW_PAYMENT_METHOD)) ||
    [];
  return newPaymentMethods?.includes(paymentMethod);
};

export const getAddCardIcon = (isMaxLimitReached, toggleAddCard) => {
  if (isMaxLimitReached) {
    return DISABLED_ICON;
  }
  return toggleAddCard ? MINIMIZE_CARD_ICON : ADD_ICON;
};

export const appDownloadFeature = (currentScreen, accountType) => {
  if (accountType === CORPORATE) return false;
  const showOnCurrentScreen = ['signin', 'signup'].includes(currentScreen);
  const neverShowStatus = window.localStorage.getItem(NEVER_SHOW);
  const isFeatureEnabled = isFlagEnabled(APP_DOWNLOAD_PROMOTION);
  let utmCookie = getCookie('utm');
  if (utmCookie) utmCookie = JSON.parse(utmCookie);
  const isPartnerDisabled = getFlagValue(APP_DOWNLOAD_PROMOTION)?.includes(utmCookie?.utm_campaign);
  const showPopup =
    !neverShowStatus && showOnCurrentScreen && isFeatureEnabled && !isPartnerDisabled;
  if (showPopup) injectIntoDataLayer('Download_' + currentScreen, { page_name: currentScreen });
  return showPopup;
};

export const getPaymentFeeAmountNote = (payment_method_fee_cumulative_amount, source_currency) => {
  const note = payment_method_fee_cumulative_amount
    ? `${payment_method_fee_cumulative_amount.toLocaleString()} ${source_currency}`
    : 'No';
  return note + ' fee';
};

export const fetchTimeRemainingWithValidity = ({
  startTime,
  endTime = moment(),
  validityInHour = 36
}) => {
  const startDate = moment(startTime).add(validityInHour, 'hours');

  // get the difference between the moments
  const hour = startDate.diff(endTime, 'hours');
  const minutes = startDate.diff(endTime, 'minutes');
  const seconds = startDate.diff(endTime, 'seconds');

  const result = {
    valid: false,
    difference: {}
  };

  if (hour > 0) {
    result['valid'] = true;
    result['difference'] = {
      remainingHour: hour,
      remainingMinute: minutes % 60,
      remianingSecond: seconds % 60
    };
  }
  return result;
};

export const previewChooser = (filesData) => {
  const { fileSrc, attachment_url, name, actual_file_name } = filesData;
  const fileExtension = getFileExtension(name || actual_file_name).toLowerCase();
  let result = { fileSrc: '', previewAvailable: false };
  if (FILE_FORMAT_EXT_IMAGE_ONLY.includes(fileExtension))
    result = { fileSrc: attachment_url || fileSrc, previewAvailable: true };
  else if (FILE_FORMAT_DOCUMENT_ONLY.includes(fileExtension))
    result = { fileSrc: DOC_FILE_ICON, previewAvailable: false };
  else if (FILE_FORMAT_VIDEO_ONLY.includes(fileExtension))
    result = { fileSrc: VIDEO_FILE_ICON, previewAvailable: false };
  else if (FILE_FORMAT_DOCUMENT_PDF_ONLY.includes(fileExtension))
    result = { fileSrc: PDF_FILE_ICON, previewAvailable: false };
  return result;
};

export const previewChooserforZenDesk = (filesData) => {
  const { contentType, mappedContentUrl, fileName } = filesData;
  const fileExtension = getFileExtension(fileName)?.toLowerCase();
  let result = { fileSrc: '', previewAvailable: false };
  if (FILE_FORMAT_EXT_IMAGE_ONLY.includes(fileExtension))
    result = { fileSrc: mappedContentUrl || contentType, previewAvailable: true };
  else if (FILE_FORMAT_DOCUMENT_ONLY.includes(fileExtension))
    result = { fileSrc: DOC_FILE_ICON, previewAvailable: false };
  else if (FILE_FORMAT_VIDEO_ONLY.includes(fileExtension))
    result = { fileSrc: VIDEO_FILE_ICON, previewAvailable: false };
  else if (FILE_FORMAT_DOCUMENT_PDF_ONLY.includes(fileExtension))
    result = { fileSrc: PDF_FILE_ICON, previewAvailable: false };
  return result;
};

export const fetchGAClientId = () => {
  return document.querySelectorAll('[name=tracking_ga_cid]')[0]?.value || '';
};

export const getNavigatorLanguage = () =>
  navigator.languages && navigator.languages.length
    ? navigator.languages[0]
    : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en';

export const amountOrCurrencyChangeCT = (value, event_name) => {
  const eventProperties = {};
  if (
    [
      PARAMETER_CHANGE.SOURCE_CURRENCY_CHANGE,
      PARAMETER_CHANGE.DESTINATION_CURRENCY_CHANGE
    ].includes(event_name)
  ) {
    eventProperties.currency = value;
  } else {
    eventProperties.amount = parseFloat(value.replace(/[^0-9.]/g, ''));
  }
  logEvent(event_name, FLOW_TYPE_SEND_MONEY, eventProperties, LOG_TYPE.CLEVER_TAP);
};

export const replaceNewLineByBR = (textValue) => {
  return textValue ? textValue.replace(/(?:\r\n|\r|\n)/g, '<br />') : textValue;
};

export const processInstaPointsHistoryData = (history) => {
  let instapoints_redeemed = 0,
    instapoints_earned = 0;
  // eslint-disable-next-line array-callback-return
  history.map((data) => {
    if (data.category === 'EARNED') instapoints_earned += data.instapoints;
    else if (data.category === 'REDEEMED') instapoints_redeemed += data.instapoints;
  });
  return { instapoints_earned, instapoints_redeemed };
};

export const getLottieJson = async (url) => {
  const response = await fetch(url);
  const jsonData = await response.json();
  return jsonData;
};

export const isMobileDevice = () => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
    return true;
  return false;
};

export const isNewOnboardingEnabledCountry = (countyCode) =>
  NEW_ONBOARDING_FLOW_COUNTRY_LIST.map((country) => country.code).includes(countyCode) || false;

export const getUTMQueryInString = () => {
  let utmCookie = getCookie('utm');
  const clickrefCookie = getCookie('clickref');
  let appendUtmQueryString = '?';
  if (utmCookie) {
    utmCookie = JSON.parse(utmCookie);
    for (const [key, value] of Object.entries(utmCookie)) {
      appendUtmQueryString += `&${key}=${value}`;
    }
  } else {
    appendUtmQueryString = '';
  }

  if (clickrefCookie) {
    appendUtmQueryString += `${utmCookie ? '&' : '?'}clickref=${clickrefCookie}`;
  }
  return appendUtmQueryString;
};
export const getFileSrcAsBase64 = (file) => {
  return new Promise((resolve) => {
    let baseURL = '';
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};
export const getCountryNameByCode = (code) => {
  const country = NEW_ONBOARDING_FLOW_COUNTRY_LIST.find((country) => country.code === code);
  return country ? country.name : '';
};

export const isRatedOnTrustPilot = () => {
  const currentTimestamp = Date.now();
  const storedTimestamp = localStorage.getItem('lastRatedOnTrustPilot');
  if (storedTimestamp) {
    const timeDifference = currentTimestamp - parseInt(storedTimestamp);
    const daysDifference = parseInt(timeDifference / (1000 * 60 * 60 * 24));
    if (daysDifference < 120) {
      return true;
    }
  }
  return false;
};

export const sendUpsellingTransactionInitiateEvent = (finalTxnObject) => {
  try {
    const { source_currency, destination_currency, net_source_amount } = finalTxnObject;
    let upSellingPopupSessionData = sessionStorage.getItem(UPSELLING_MODAL_SESSION_KEY) || '{}';
    upSellingPopupSessionData = JSON.parse(upSellingPopupSessionData);
    const filterUpsellingPopupDataCurrenyPair =
      upSellingPopupSessionData[`${source_currency}-${destination_currency}`];
    const {
      upsellDestinationCurrency,
      upsellEndRangeAmount,
      upsellSourceAmount,
      upsellSourceCurrency
    } = filterUpsellingPopupDataCurrenyPair || {};
    if (
      source_currency === upsellSourceCurrency &&
      destination_currency === upsellDestinationCurrency &&
      net_source_amount >= upsellEndRangeAmount
    ) {
      const ctData = {
        sourceCurrency: source_currency,
        destinationCurrency: destination_currency,
        initalSourceAmount: upsellSourceAmount,
        finalSourceAmount: net_source_amount
      };
      logEvent(UPSELLING_TRANSACTION_INITIATED, FLOW_TYPE_SEND_MONEY, ctData, LOG_TYPE.CLEVER_TAP);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Error sending UPSELLING_TRANSACTION_INITIATED event');
  }
};

export const maskData = (data, isEmail = false) => {
  if (isEmail) {
    if (!data) return '';
    const atIndex = data.indexOf('@');
    return atIndex > 0 ? data[0] + '****' + data.slice(atIndex) : data;
  } else return data.replace(/\d(?=\d{4})/g, '*');
};

export const calculateRemainingTime = (created_at, cancellation_hours) => {
  const createdAtTimestamp = moment.utc(created_at, 'DD MMM YYYY h:mm A');
  const expirationTime = createdAtTimestamp.add(cancellation_hours, 'hours');

  const currentUTCTime = moment.utc(); // Get current time in UTC

  if (currentUTCTime.isAfter(expirationTime)) {
    return false; // Time has expired
  }

  const duration = moment.duration(expirationTime.diff(currentUTCTime));

  const totalRemainingHours = duration.hours() + duration.days() * 24;
  const remainingMinutes = duration.minutes();
  const remainingSeconds = duration.seconds();

  return {
    hours: totalRemainingHours,
    minutes: remainingMinutes,
    seconds: remainingSeconds
  };
};

/* logging function will be replaced by Varsha */
export const logReferralCodeAndTermsCondition = (
  country_code,
  referred_by_referral_code,
  is_term_conditions_accepted
) => {
  const ctData = {
    pageName: 'Signup'
  };
  setTimeout(() => {
    if (country_code) {
      logEvent('countryOnbDone', FLOW_TYPE_ONBOARDING, ctData, LOG_TYPE.CLEVER_TAP);
    }
    if (referred_by_referral_code) {
      ctData.referral_code = referred_by_referral_code;
      logEvent('referralCodeFilled', FLOW_TYPE_ONBOARDING, ctData, LOG_TYPE.CLEVER_TAP);
    }
    if (is_term_conditions_accepted) {
      logEvent('tAndCFilled', FLOW_TYPE_ONBOARDING, ctData, LOG_TYPE.CLEVER_TAP);
    }
  }, [10000]); //Profile creation of clevertap from backend takes usually 10seconds.
};

export const getCountryConsolidated = (country_code) => {
  return country_code === 'GB' ? 'GB' : EU_REGION.includes(country_code) ? 'EU' : country_code;
};

export const handleSignupLoggingAndSessionStorage = (
  customer_id,
  auth_type,
  email,
  user_id,
  utmCampaigningCookie,
  is_term_conditions_accepted,
  account_type,
  country_code,
  referred_by_referral_code,
  csrf_token,
  dispatch,
  remitter_id,
  device_id
) => {
  const logObject = {
    signUpMethod: auth_type ? startCase(toLower(auth_type)) : 'Email',
    Email: email?.toLowerCase(),
    CIN: customer_id,
    accountType: startCase(toLower(account_type)),
    Identity: remitter_id,
    remitterCountry: country_code,
    userId: user_id,
    countryConsolidated: getCountryConsolidated(country_code),
    deviceId: device_id
  };
  logEvent(
    SIGNUP,
    FLOW_TYPE_ONBOARDING,
    {
      ...logObject,
      remitterCountry: country_code,
      ...utmCampaigningCookie
    },
    LOG_TYPE.CLEVER_TAP,
    true,
    logObject
  );
  logEvent(
    SIGNUP,
    FLOW_TYPE_ONBOARDING,
    {
      ...logObject,
      remitterCountry: country_code,
      userId: user_id
    },
    LOG_TYPE.GA
  );
  deleteCookie(REFERRAL_CODE);
  pushGeoLocationDataToCT();
  localStorage.setItem('eKYCRetryCount', EKYC_RETRY_COUNT);
  sessionStorage.setItem(IP_MODAL_OPEN, true);
  dispatch({ type: SET_NEW_SIGNUP_USER });
  dispatch(setCsrfToken(csrf_token));

  logReferralCodeAndTermsCondition(
    country_code,
    referred_by_referral_code,
    is_term_conditions_accepted
  );
};

export const showIpScreen = async (country_code, account_type, instapointsResponse) => {
  const isNiumForexUser = country_code === IN;
  let isSplitKYCFlow;
  if (!isNiumForexUser) {
    isSplitKYCFlow = isKYCSplitFlow(country_code, '', true, account_type);

    const sourceCurrency = await getSourceCurrencies(country_code);
    const sourceCurrencyList = get(sourceCurrency, 'data.data', []);

    const { redemption_value = 0 } = instapointsResponse;
    let value = redemption_value * 100;
    //to check no is decimal or not and + to convert string to no.
    if (value % 1 !== 0) value = +value.toFixed(2);
    await ModalFactory.builder(
      (onClose) => {
        return (
          <NewInstapointsLogic
            onClose={onClose}
            value={value}
            source_currency={sourceCurrencyList[0].value}
            isSplitKYCFlow={isSplitKYCFlow}
          />
        );
      },
      'new-instapoint-modal',
      true
    );
  }
  let redirectLink = USER_REGISTRATION_URL;
  if (isSplitKYCFlow) {
    redirectLink = DASHBOARD_URL;
  } else if (country_code === 'SG') {
    redirectLink = MY_INFO_RESGISTRATION_URL;
  }
  return redirectLink;
};
export const isEuCorridor = (country) => {
  return EU.includes(country);
};

export const generateRandomStringId = (length = 32) => {
  const randomBytesArray = new Uint8Array(length);
  window.crypto.getRandomValues(randomBytesArray);
  return CryptoJS.enc.Base64.stringify(CryptoJS.lib.WordArray.create(randomBytesArray))
    .replace(/[^a-zA-Z0-9]/g, '')
    .substring(0, length)
    .toLowerCase();
};

export const shouldShowPaymentOptionTab = (countryCode) => {
  if (!isFlagEnabled(MANAGE_PAYMENT_OPTION_FLAG)) {
    // If flag disabled - then show that Tab
    return true;
  }
  const managePaymentOptionFlag = getFlagValue(MANAGE_PAYMENT_OPTION_FLAG);
  let paymentOptionTabVisible = true;
  if (managePaymentOptionFlag) {
    if (EU.includes(countryCode)) countryCode = 'EU';
    paymentOptionTabVisible =
      !managePaymentOptionFlag.manage_payment_option_disabled_countries?.includes(countryCode);
  }
  return paymentOptionTabVisible;
};

export const getManagePaymentFlagValue = (countryCode) => {
  const managePaymentOptionFlag = getFlagValue(MANAGE_PAYMENT_OPTION_FLAG);
  if (EU.includes(countryCode)) countryCode = 'EU';
  const creditCardDisabled =
    managePaymentOptionFlag?.credit_card_disabled_countries?.includes(countryCode);
  const debitCardDisabled =
    managePaymentOptionFlag?.debit_card_disabled_countries?.includes(countryCode);
  return { creditCardDisabled, debitCardDisabled };
};

const showOtherNote = (countryCode, nationality) =>
  EU_REGION.includes(countryCode) && EU.includes(nationality);

export const getConditionalNote = (ekycData, countryCode, nationality) => {
  if (countryCode === 'MY') {
    return nationality === 'MY' ? ekycData?.checkPoint?.note1 : ekycData?.checkPoint?.note1ForOther;
  } else if (showOtherNote(countryCode, nationality)) {
    return ekycData?.checkPoint?.note1ForOther;
  } else {
    return ekycData?.checkPoint?.note1;
  }
};

export const getThresholdLimit = (thresholdValues, countryCode, currency) => {
  let valuePath = [countryCode, currency, 'amount'];
  let enabledPath = [countryCode, currency, 'enabled'];
  if (EU.includes(countryCode)) {
    valuePath = ['EU', currency, 'amount'];
    enabledPath = ['EU', currency, 'enabled'];
  }
  const finalValue = get(thresholdValues, valuePath, 0);
  const enabled = get(thresholdValues, enabledPath, false);
  return {
    enabled: enabled,
    thresholdLimit: finalValue
  };
};

export const isNonHighValueOrDefaultTier = (tierName) => {
  return !['DEFAULT', 'DEFAULT_HIGH_VALUE'].includes(tierName);
};

export const isCurrencyPairInTierList = (sourceCurrency, destinationCurrency) => {
  const tierList = store.getState().rootReducer?.userStatusReducer?.nthTransactionTier;
  return tierList?.find(
    (tier) =>
      tier.source_currency === sourceCurrency &&
      tier.destination_currency.includes(destinationCurrency)
  );
};

export const clearNecessaryLS = () => {
  localStorage.removeItem('SINGPASS_RFI_FLOW');
};

export const base64ToImageFile = (base64Data, fileName, fileType) => {
  const binaryString = atob(base64Data);
  const byteArray = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    byteArray[i] = binaryString.charCodeAt(i);
  }
  const blob = new Blob([byteArray], { type: fileType });
  const file = new File([blob], fileName, { type: fileType });
  return file;
};

export const loadRecaptchaScript = () => {
  return new Promise((resolve, reject) => {
    // Check if script is already loaded
    if (window.grecaptcha || document.querySelector('script[src*="recaptcha/enterprise.js"]')) {
      resolve();
      return;
    }

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${import.meta.env.VITE_ENTERPRISE_CAPTCHA_KEY_V3}`;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA script'));

    document.head.appendChild(script);
  });
};

export const isDynamicRouteMatch = (actualPath, pathArray) => {
  return pathArray.some((pattern) => {
    // Direct string match (for exact paths like "/dashboard")
    if (actualPath === pattern) return true;

    // Pattern match (for dynamic routes like "/acknowledgement/:id")
    return matchPath(pattern, actualPath) !== null;
  });
};

export const getAbsolutePath = (url) => {
  if (!url) return DEFAULT_AUTH_PATH;
  if (url.startsWith('/')) return url;
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `${BASE_URL}/${url}`;
};

/** * returns true if Apple Pay can be shown based on the platform requirements
 * @typedef {import('../screens/user-flow/payment-method/paymentMethodV2/types').instarem_accounts} instarem_accounts
 * @param {instarem_accounts} object
 * @returns {boolean}
 */
export const isAllowedToShowApplePay = (object, email) => {
  if (!object) return false;
  const { min_macOS_version = 0, min_safari_version = 0 } =
    object.platform_version_requirements || {};
  const { browser = {}, os = {} } = parseUserAgent(window.navigator.userAgent) || {};
  const name = (browser.name || '').toLowerCase();
  const osMajor = parseFloat((os.version || '0').split('.').slice(0, 2).join('.')) || 0;
  const browserMajor = parseFloat((browser.version || '0').split('.').slice(0, 2).join('.')) || 0;

  // show Apple Pay only if the flag is enabled otherwise return false and hide Apple Pay
  // check for all the platform requirements only after the user is allowed to see Apple Pay via flag
  if (isFlagEnabled(APPLE_PAY_CONFIG)) {
    const value = getFlagValue(APPLE_PAY_CONFIG).enabledUsers;
    const enabledUsersLower = value.map((e) => (e ?? '').toLowerCase());
    const emailLower = (email ?? '').toLowerCase();
    if (enabledUsersLower.includes(emailLower) || value.length === 0) {
      if (!object || name.includes('firefox')) return false;

      if (name.includes('safari')) {
        return osMajor >= min_macOS_version && browserMajor >= min_safari_version;
      }
      return osMajor >= min_macOS_version;
    } else {
      return false;
    }
  }
  return false;
};

/**
 *
 *
 * filters out Apple Pay payment method from the list of available payment methods if the current browser is
 * Firefox or a Firefox based browser
 *
 * @typedef {import('../screens/user-flow/payment-method/paymentMethodV2/types').instarem_accounts} instarem_accounts
 *
 * @param {Array<instarem_accounts>} paymentMethods
 * @param {string} countryCode
 * @returns {Array<instarem_accounts>}
 */
export const filterApplePayPaymentMethod = (paymentMethods, email) => {
  const applePayPaymentMethodObject = paymentMethods.find(
    (paymentMethod) => paymentMethod.code === STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE
  );

  if (!isAllowedToShowApplePay(applePayPaymentMethodObject, email)) {
    return paymentMethods.filter(
      (paymentMethod) => paymentMethod.code !== STRIPE_APPLE_PAY_PAYMENT_METHOD_CODE
    );
  }
  return paymentMethods;
};

export const replaceParams = (url, params = {}) => {
  let finalUrl = url;

  Object.entries(params).forEach(([key, value]) => {
    const placeholder = `{{${key}}}`;
    finalUrl = finalUrl.replaceAll(placeholder, value ?? '');
  });

  return finalUrl;
};

export const formatNumberTwoDecimals = (value) => {
  const formatter = new Intl.NumberFormat('en', { maximumFractionDigits: 2 });
  return formatter.format(value);
};

export function isIframeWindow() {
  const isInIframe = window.self !== window.top;
  return isInIframe;
}

export function showIframeErrorPopup(show, message) {
  const iframeModalElement = window.parent.document.getElementById('iframe-error-popup');
  const contentDiv = iframeModalElement.querySelector('.content-inner-wrapper');
  const titleMsgDiv = contentDiv.querySelector('.iframe-modal-title-msg');
  if (titleMsgDiv && message && message.length > 0) {
    titleMsgDiv.textContent = message;
  }
  if (show) {
    iframeModalElement.classList.remove('d-none');
  } else {
    iframeModalElement.classList.add('d-none');
  }
}
